import React from 'react';
import { PropTypes as PT } from 'prop-types';
import { defineMessages } from 'react-intl';
import onClickOutside from 'react-onclickoutside';
import classes from './SharingPermissionsModal.module.scss';

const messages = defineMessages({
  notAllowedError1: {
    id: 'presentation.notAllowedError1',
    defaultMessage: 'Update your privacy settings to allow Chrome to share the content of your screen.'
  },
  notAllowedError2: {
    id: 'presentation.notAllowedError2',
    defaultMessage: 'Go to System Preferences > Security & Privacy > Privacy > Screen Recording. Select the checkbox next to Chrome to allow screen sharing.'
  },
  title: {
    id: 'components.sharingPermissions.title',
    defaultMessage: 'Please update your privacy settings'
  }
});

class SharingPermissionsModal extends React.PureComponent {
  handleClickOutside() {
    this.props.closeInCallModal();
  }

  render() {
    const { i18nMessages } = this.props;

    return (
      <div className={classes.container}>
        <header>
          <div className={classes.headerBar}>
            {
              `${i18nMessages[messages.title.id]}`
            }
          </div>
        </header>
        <div className={classes.content}>
          <div className={classes.instructions}>
            {
              `${i18nMessages[messages.notAllowedError1.id]}`
            }
          </div>
          <div className={classes.instructions}>
            {
              `${i18nMessages[messages.notAllowedError2.id]}`
            }
          </div>
        </div>
        <img src="/images/catalina_instructions.gif" alt="Catalina Instructions"/>
      </div>
    );
  }
}

SharingPermissionsModal.propTypes = {
  closeInCallModal: PT.func,
  i18nMessages: PT.array
};

export default onClickOutside(SharingPermissionsModal);
